const joinWithUnderscore = (inputString) => {
  return inputString?.split(' ').join('_');
};

export default joinWithUnderscore;
